
import { motion } from "framer-motion";

interface AboutHeroProps {}

const AboutHero = ({}: AboutHeroProps) => {
  return (
    <section className="relative px-4 py-24 bg-gradient-to-r from-corporate-primary-100 to-corporate-primary-75 text-white">
      <div className="absolute inset-0 bg-[url('/lovable-uploads/8fd12166-0122-42a4-9da3-b430e2991c7a.png')] bg-center bg-no-repeat opacity-10"></div>
      <div className="max-w-4xl mx-auto text-center relative z-10">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="flex items-center justify-center mb-4"
        >
          <div className="h-1 w-20 bg-corporate-secondary-100 mr-4"></div>
          <span className="text-corporate-secondary-75 font-semibold">ABOUT METRADE</span>
          <div className="h-1 w-20 bg-corporate-secondary-100 ml-4"></div>
        </motion.div>
        <motion.h1 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-4xl sm:text-5xl font-bold mb-6 leading-tight"
        >
          Our Vision & Approach
        </motion.h1>
        <motion.p 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="text-xl opacity-90 max-w-2xl mx-auto"
        >
          Opening doors to everyone in the world of crypto trading
        </motion.p>
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-white to-transparent"></div>
    </section>
  );
};

export default AboutHero;
